import { create } from "zustand";
import { persist } from "zustand/middleware";
import { getFilteredSelectedTables, tableLayoutDefaultSummary } from "../utils/store.helper";

const useTableManagementStorage = create(
  persist(
    (set, get) => ({
      floorTabActiveKey: "",
      modalActionMode: "",
      idWiseSelectedTablesOrg: {},
      idWiseSelectedTables: {}, // session id wise tableInfo. session id can be order id or tab id (UUID)
      idWiseGuestNumber: {}, // session id wise guest number storing
      layoutSummary: { ...tableLayoutDefaultSummary },
      layoutFloors: {},
      setFloorTabActiveKey: (val) => {
        set({
          floorTabActiveKey: val,
        });
      },
      setModalActionMode: (val) => {
        set({
          modalActionMode: val,
        });
      },
      setIdWiseGuestNumber: (sesId, guestNumber) => {
        set((state) => ({
          idWiseGuestNumber: {
            ...state.idWiseGuestNumber,
            [sesId]: guestNumber,
          },
        }));
      },
      getIdWiseSelectedTables: (sesId) => {
        const tmp = get().idWiseSelectedTables;
        return tmp.hasOwnProperty(sesId) ? tmp[sesId] : [];
      },
      addIdWiseSelectedTables: (sesId, tableInfo) => {
        set((state) => ({
          idWiseSelectedTables: {
            ...state.idWiseSelectedTables,
            [sesId]: getFilteredSelectedTables(tableInfo, state.idWiseSelectedTables[sesId] || []),
          },
        }));
      },
      replaceIdWiseSelectedTables: (sesId, tableInfoArr = []) => {
        set((state) => ({
          idWiseSelectedTables: {
            ...state.idWiseSelectedTables,
            [sesId]: tableInfoArr,
          },
        }));
      },
      getIdWiseSelectedTablesOrg: (sesId) => {
        const tmp = get().idWiseSelectedTablesOrg;
        return tmp.hasOwnProperty(sesId) ? tmp[sesId] : [];
      },
      addIdWiseSelectedTablesOrg: (sesId, tableInfoArr = []) => {
        set((state) => ({
          idWiseSelectedTablesOrg: {
            ...state.idWiseSelectedTablesOrg,
            [sesId]: tableInfoArr,
          },
        }));
      },
      setLayoutSummary: (summary) => {
        set({
          layoutSummary: summary,
        });
      },
      setALayoutFloor: (floorId, record) => {},
      updateLayoutFloors: (floorId, updates) => {
        set((state) => {
          const floors = state.layoutFloors;
          const floor = floors[floorId];

          if (!floor) return;

          let changed = false;

          const updatedTables = floor.tables.map((tbl) => {
            const update = updates.find((u) => u.id === tbl.id);

            if (update) {
              changed = true;
              return { ...tbl, ...update }; // merge partial update
            }

            return tbl;
          });

          if (!changed) return; // nothing changed → skip persist/rerender

          return {
            layoutFloors: {
              ...floors,
              [floorId]: {
                ...floor,
                tables: updatedTables,
              },
            },
          };
        });
      },

      setLayoutFloors: (floors) => {
        set({
          layoutFloors: floors,
        });
      },
      resetStore: () => {
        set({ floorTabActiveKey: '', modalActionMode: '', idWiseSelectedTablesOrg: {}, idWiseGuestNumber: {}, idWiseSelectedTables: {}, layoutSummary: { ...tableLayoutDefaultSummary }, layoutFloors: {} });
      },
    }),
    {
      name: "table-management-storage",
      getStorage: () => localStorage,
    }
  )
);

export default useTableManagementStorage;
